export const REG_TIME_WITH_DURATION = /^(\d+):(\d+)(?: (\d+))?$/
export const REG_DATE = /^(\d+)-(\d+)-(\d+)$/
